module.exports = __webpack_public_path__ + "img/leaf.ec4e02d5.svg";